import { fetchAPI } from "@/utils/fetchAPI";

type FetchLogin = {
  email: string;
  password: string;
};

export async function fetchLogin({ email, password }: FetchLogin) {
  const res = await fetchAPI({
    url: `/account/login`,
    options: {
      method: "POST",
      body: JSON.stringify({ email, password }),
    },
  });

  return res;
}
